import PropTypes from 'prop-types';
import SwitchMembershipSectionWrapper from "../section-wrapper";
import { useDispatch, useSelector } from 'react-redux';
import {
   memberTagsDataSelector,
   isFetchingTags as isFetchingTagsSelector,
   isFetchingCreateNewTagSelector,
   createNewTagErrorsSelector,
} from 'admin/state/modules/member-tags/selectors';
import Button from 'common/components/elements/buttons/primary';
import { addNewTagOperation, fetchMembersTagsOperation } from 'admin/state/modules/member-tags/operations';
import { useState } from 'react';
import AddMemberTags from 'admin/views/member-tags/add-member-tags';
import CreateMemberTagModal from 'admin/views/member-tags/add-member-tag';
import Router from 'admin/routes/router';
import QueryParams from 'admin/utils/QueryParams';
import MemberTagLabel from './modules/member-tag-label';
import classNames from 'classnames';
import toast from 'common/utils/toast';

const CREATE_MEMBER_TAG_OPTION_VALUES = [
   {
      value: 'high_roller',
      display_name: 'Total spent is more than 1000 USD',
   },
   {
      value: 'king',
      display_name: 'Total spent 500 - 1000 USD',
   },
   {
      value: 'prince',
      display_name: 'Total spent 250 - 500 USD',
   },
   {
      value: 'duke',
      display_name: 'Total spent 100 - 250 USD',
   },
]

const SwitchMembershipTagMembers = ({
   selectedMemberTagIds = [],
   onSelectTags,
   isOnDurationField,
   title,
   description,
}) => {
   const dispatch = useDispatch();

   const [isOpenSelectTagsModal, setIsOpenSelectTagsModal] = useState(false)
   const [isOpenCreateNewTagModal, setIsOpenCreateNewTagModal] = useState(false)

   const memberTagsList = useSelector(memberTagsDataSelector)?.data || []
   const isFetchingTags = useSelector(isFetchingTagsSelector)
   const isFetchingCreateNewTag = useSelector(isFetchingCreateNewTagSelector)
   const createNewTagErrors = useSelector(createNewTagErrorsSelector)

   const onClickAddNewTags = () => {
      if(memberTagsList.length === 0) {
         dispatch(fetchMembersTagsOperation(['count=all']))
      }

      setIsOpenSelectTagsModal(true)
   }

   const openNewTagModal = (searchedTagName) => {
      if(searchedTagName) {
         QueryParams.setQueryParam('new-tag-name', searchedTagName)
      }
      setIsOpenCreateNewTagModal(true)
   }

   const onCreateTag = (data) => {
      dispatch(addNewTagOperation(data, () => {
         setIsOpenCreateNewTagModal(false)
         QueryParams.removeQueryParam('new-tag-name')
      }))
   }

   const onRemoveTag = (tagId) => {
      const filteredList = selectedMemberTagIds.filter(id => id !== tagId)

      onSelectTags(filteredList)

      toast.success('Member tag has been removed')
   }

   return (
      <>
         <SwitchMembershipSectionWrapper
            className={ classNames({
               '!bg-panel': isOnDurationField,
            }) }
         >
            <div
               className='w-full flex flex-col gap-2'
            >
               <div
                  className='w-full flex flex-col gap-1'
               >
                  <span
                     className='text-major font-medium leading-5'
                  >
                     {title}
                  </span>
                  {
                     Boolean(description) && (

                        <span
                           className='panel-description text-secondary'
                        >
                           {description}
                        </span>
                     )
                  }
               </div>
               <div
                  className='w-full flex flex-wrap gap-2'
               >
                  {
                     selectedMemberTagIds.map(tagId => {
                        const tagItem = memberTagsList.find(item => item.id === tagId)

                        return (
                           <MemberTagLabel
                              key={ tagId }
                              name={ tagItem.name }
                              emoji={ tagItem.emoji }
                              onClickRemove={ () => onRemoveTag(tagId) }
                           />
                        )
                     })
                  }
                  <Button
                     text='Add tags'
                     iconName='add'
                     classNames='!w-fit gap-2'
                     padding={ 0 }
                     textMarginX='0'
                     primaryColor
                     backgroundColor='transparent'
                     iconPosition='left'
                     textSize='small'
                     onClick={ onClickAddNewTags }
                  />
               </div>
            </div>
         </SwitchMembershipSectionWrapper>
         {
            isOpenSelectTagsModal && (
               <AddMemberTags
                  onClose={ () => setIsOpenSelectTagsModal(false) }
                  isApplyUseEffectOnTagsData
                  isFetchingTags={ isFetchingTags }
                  tags={ memberTagsList }
                  modalTitle='Select member tags'
                  onAddTagsToMember={ (_, __, selectedTags) => {
                     onSelectTags(selectedTags)
                     setIsOpenSelectTagsModal(false)
                  } }
                  tagsOfCurrentMember={ selectedMemberTagIds.map(id => ({ id })) }
                  manageMembersTags={ () => {
                     window.open(`${ window.location.origin }${ Router.route('MEMBER_TAGS').getCompiledPath() }`, '_blank', 'noopener,noreferrer');
                  } }
                  createNewTag={ openNewTagModal }
                  optionValues={ CREATE_MEMBER_TAG_OPTION_VALUES }
                  searchPlaceholder='Search member tags'
               />
            )
         }
         {
            isOpenCreateNewTagModal && (
               <CreateMemberTagModal
                  onCloseModal={ () => setIsOpenCreateNewTagModal(false) }
                  optionValues={ CREATE_MEMBER_TAG_OPTION_VALUES }
                  showCheckbox={ false }
                  setShowCheckBox={ () => {} }
                  onSaveTag={ onCreateTag }
                  isButtonLoading={ isFetchingCreateNewTag }
                  errors={ createNewTagErrors }
               />
            )
         }
      </>
   )
}

SwitchMembershipTagMembers.propTypes = {
   selectedMemberTagIds: PropTypes.array,
   onSelectTags: PropTypes.func,
   isOnDurationField: PropTypes.bool,
   title: PropTypes.string,
   description: PropTypes.string,
}

export default SwitchMembershipTagMembers;
